import { createContext, PropsWithChildren, useEffect, useState } from 'react';
import { Backdrop } from '@mui/material';
import {logoWhiteEngMinH, logoWhiteEngMinV, logoBlackEngMinH, logoBlackEngMinV, logoBlackEngH ,logoBlackEngV ,logoBlackRusH ,logoBlackRusV ,logoWhiteEngH ,logoWhiteEngV ,logoWhiteRusH ,logoWhiteRusV  } from 'shared/assets';
import {useTheme} from "../../../app/providers/ThemeContext";

const LoaderContext = createContext(undefined);

export const LoaderProvider = ({ children }: PropsWithChildren) => {
  const [isLoading, setIsLoading] = useState(true);
  const { themeMode } = useTheme();
  const [curentLogo, setcurentLogo] = useState(logoWhiteEngMinH);


  useEffect(() => {
    if(themeMode == 'light') {
      setcurentLogo(logoWhiteEngMinH);
    } else {
      setcurentLogo(logoBlackEngMinH);
    }

    const loading = setTimeout(() => setIsLoading(false), 2000);

    return () => clearTimeout(loading);
  }, [themeMode]);

  return (
    <LoaderContext.Provider value={undefined}>
      {isLoading ? (
        <Backdrop open={isLoading} sx={{ zIndex: 99, background: 'transparent', transition: 'all 0.5s ease-out' }}>
          <img src={curentLogo} height={55} alt="loader" />
        </Backdrop>
      ) : (
        children
      )}
    </LoaderContext.Provider>
  );
};
